import React from "react";

import blogData from "../config/blogPage";
import StandardSizeContainer from "../customComponent/Container/StandardSizeContainer";
import SubTitle from "../customComponent/Title/SubTitle";
import CustomParagraph from "../customComponent/Title/CustomParagraph";
import { Container } from "../components/container/Container";
import BlogsCard from "../customComponent/Card/BlogsCard";
import SectionHeadingTitle from "../customComponent/Title/SectionHeadingTitle";
import BlogTwoSection from "../customComponent/TwoSections/BlogTwoSection";
import IconWithLink from "../customComponent/Link/IconWithLink";
import BlogsComingSoon from "../customComponent/BlogsComingSoon";

const BlogPage = () => {
  const {
    subTitle,
    description,
    descriptionTwo,
    latestPostsTitle,
    posts,
  } = blogData.blogSection;
  return (
    <StandardSizeContainer>
      {/* <HeadingTitle text={title} /> */}
      <SubTitle text={subTitle} />
      <CustomParagraph text={description} />
      <CustomParagraph text={descriptionTwo} />
      <Container className=" text-center py-6">
        {/* <SectionHeadingTitle text={latestPostsTitle} />
        <BlogsCard blogs={posts} /> */}
        <BlogsComingSoon />
      </Container>
      <Container className="text-center py-6 px-4">
        <SectionHeadingTitle text={blogData.whyFollowBlog.title} />
        <BlogTwoSection data={blogData.whyFollowBlog.reasons} />
      </Container>

      <Container className="max-w-4xl mx-auto text-center py-6">
        <SectionHeadingTitle text={blogData.contributeSection.title} />
        <CustomParagraph text={blogData.contributeSection.description} />
        <IconWithLink
          src={blogData.contributeSection.icon}
          link={`${blogData.contributeSection.email.trim()}`}
        />
      </Container>
    </StandardSizeContainer>
  );
};

export default BlogPage;
